module.exports = __webpack_public_path__ + "static/media/logo-palmeirastocantins.b0636cb3.png";